export default {
  title: 'Informazioni aziendali',
  form: {},
  buttons: {
    save: 'Salva',
  },
  toasts: {
    success: 'Informazioni salvate con successo.',
  },
};
